import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { FilterChip } from 'components';
import _ from 'lodash';
import _debug from 'debug';
import * as util from 'lib/utility';
import * as actions from 'state/modules/filter';
import { VirtualizedSelect } from 'containers';
import { Button } from 'react-toolbox/lib/button';
import styles from './Filter.css';

const debug = _debug('app:Filter');
let warmLeadsCount = '';

export class Filter extends Component {
  static defaultProps = {
    options: []
  }
  static propTypes = {
    flexValues: PropTypes.arrayOf(PropTypes.number),
    updateFilterExpanded: PropTypes.func,
    filterExpanded: PropTypes.bool,
    filterData: PropTypes.arrayOf(PropTypes.shape({})),
    updateFilter: PropTypes.func,
    applyFilter: PropTypes.func,
    clearFilter: PropTypes.func,
    list: PropTypes.arrayOf(React.PropTypes.shape({})),
    leadsData: PropTypes.arrayOf(PropTypes.shape({})),
    activeFilter: PropTypes.string,
    activeFilterReplica: PropTypes.arrayOf(PropTypes.shape({})),
    setActiveFilter: PropTypes.func,
    agentList: PropTypes.shape({}),
    replicateActiveFilter: PropTypes.func,
    resetActiveFilter: PropTypes.func,
    filterValues: PropTypes.shape({
      city: PropTypes.arrayOf(PropTypes.string),
      county: PropTypes.arrayOf(PropTypes.string),
      lastAssigned: PropTypes.arrayOf(PropTypes.string),
      lastSelling: PropTypes.arrayOf(PropTypes.string),
      leadType: PropTypes.arrayOf(PropTypes.string),
      state: PropTypes.arrayOf(PropTypes.string),
      zip: PropTypes.arrayOf(PropTypes.number),
      lineOneManager: PropTypes.arrayOf(PropTypes.string),
      assignedTo: PropTypes.arrayOf(PropTypes.string),
      disposition: PropTypes.arrayOf(PropTypes.string),
      campaign: PropTypes.arrayOf(PropTypes.string),
      isOrphaned: PropTypes.bool,
      tier: PropTypes.arrayOf(PropTypes.string)
    }),
    activeIndex: PropTypes.number,
    strings: React.PropTypes.shape({}),
    updateNameSearchParameter: PropTypes.func,
    updateStreetSearchParameter: PropTypes.func,
    updatePhoneParameter: PropTypes.func,
    currentLanguage: PropTypes.string,
    isFiltered: PropTypes.bool,
    updateSelectedRecords: PropTypes.func,
    loginUserRecord: PropTypes.shape({})
  }

  constructor(props) {
    super(props);
    debug('Within Filter Component');
  }

  setFilterChipValues = () => {
    debug('Active Index ', this.props.activeIndex);
    const { strings } = this.props;
    if (__MANAGE__) {
      return [
        { label: strings.none, value: -1, paddingLeft: 10 },
        { label: (this.props.filterValues.leadType[0] || strings.none),
          value: this.props.filterValues.leadType.length,
          paddingLeft: 5,
          campname: this.props.filterValues.campaign[0],
          id: this.props.filterValues.campaign.length,
          leadTypeData: this.props.filterValues.leadType },
        { label: strings.none, value: -1, paddingLeft: 0 },
        { label: strings.none, value: -1, paddingLeft: 0 },
        { label: strings.none, value: -1, paddingLeft: 0 },
        { label: (this.props.filterValues.city[0] || strings.none),
          value: this.props.filterValues.city.length,
          paddingLeft: 20
        },
        { label: (this.props.filterValues.zip[0] || strings.none),
          value: this.props.filterValues.zip.length,
          paddingLeft: 5
        },
        { label: (this.props.filterValues.disposition[0] || strings.none),
          value: this.props.filterValues.disposition.length,
          paddingLeft: 14
        },
        { label: strings.none, value: -1, paddingLeft: 0 },
      ];
    }
    if (this.props.activeIndex === 0 || this.props.activeIndex === 1) {
      const filterChipTextAssignment = [
        { label: strings.none, value: -1 },
        { label: (this.props.filterValues.state[0] || strings.none),
          value: this.props.filterValues.state.length
        },
        { label: (this.props.filterValues.county[0] || strings.none),
          value: this.props.filterValues.county.length
        },
        { label: (this.props.filterValues.city[0] || strings.none),
          value: this.props.filterValues.city.length
        },
        { label: (this.props.filterValues.zip[0] || strings.none),
          value: this.props.filterValues.zip.length
        },
        { label: (this.props.filterValues.leadType[0] || strings.none),
          value: this.props.filterValues.leadType.length,
          campname: this.props.filterValues.campaign[0],
          id: this.props.filterValues.campaign.length,
          leadTypeData: this.props.filterValues.leadType
        },
        { label: strings.none, value: -1 },
        { label: (this.props.filterValues.lastAssigned[0] || strings.none),
          value: this.props.filterValues.lastAssigned.length
        },
        { label: (this.props.filterValues.lastSelling[0] || strings.none),
          value: this.props.filterValues.lastSelling.length
        },
        { label: (this.props.filterValues.tier[0] || strings.none),
          value: this.props.filterValues.tier.length,
          marginRight: -32
        }
      ];
      return filterChipTextAssignment;
    }
    const filterChipTextManage = [
      { label: strings.none, value: -1 },
      { label: (this.props.filterValues.state[0] || strings.none),
        value: this.props.filterValues.state.length
      },
      { label: (this.props.filterValues.county[0] || strings.none),
        value: this.props.filterValues.county.length
      },
      { label: (this.props.filterValues.city[0] || strings.none),
        value: this.props.filterValues.city.length
      },
      { label: (this.props.filterValues.zip[0] || strings.none),
        value: this.props.filterValues.zip.length
      },
      { label: (this.props.filterValues.leadType[0] || strings.none),
        value: this.props.filterValues.leadType.length,
        campname: this.props.filterValues.campaign[0],
        id: this.props.filterValues.campaign.length,
        leadTypeData: this.props.filterValues.leadType
      },
      { label: strings.none, value: -1 },
      { label: (this.props.filterValues.assignedTo[0] || strings.none),
        value: this.props.filterValues.assignedTo.length
      },
      { label: (this.props.filterValues.disposition[0] || strings.none),
        value: this.props.filterValues.disposition.length
      },
      { label: (this.props.filterValues.tier[0] || strings.none),
        value: this.props.filterValues.tier.length,
        marginRight: -32
      }
    ];
    return filterChipTextManage;
  }

  getLastSellingAgentList = () => {
    const mainList = this.props.leadsData.filter(obj => !obj.isSecondary);
    const lastSellingAgentList = [];
    mainList.forEach((element) => {
      const lastSellingAgentName = element.lastSelling;
      if (lastSellingAgentName) {
        lastSellingAgentList.push(lastSellingAgentName);
      }
    });
    return lastSellingAgentList;
  }

  filterClick = () => {
    debug('Filter button clicked...');
    this.props.updateFilterExpanded(!this.props.filterExpanded);
  }

  clearAll = () => {
    if (!__MANAGE__) {
      this.props.updateSelectedRecords('removeAll');
    }
    this.props.clearFilter();
    this.props.applyFilter();
    // this.props.updateSelectedRecords('removeAll');
    this.props.updateNameSearchParameter('', this.props.activeIndex);
    this.props.updateStreetSearchParameter('', this.props.activeIndex);
    this.props.updatePhoneParameter('', this.props.activeIndex);
    this.props.resetActiveFilter();
  }

  checkToDisable = (columnData, item) => {
    const found = _.find(this.props.list, [columnData, util.toTitleCase(item)]);
    let disable;
    if (found) {
      disable = !_.has(found, columnData);
    } else {
      disable = true;
    }
    return disable;
  }

  fillOptions = (column) => {
    let columnData = '';
    columnData = util.filterDataCRMFieldMapper(column, this.props.strings);
    const mainList = this.props.leadsData.filter(obj => !obj.isSecondary);
    // let lastSellingAgentList = [];
    if (columnData === 'leadType') {
      debug('in the leadType');
      let warmLeadsFilter = '';
      if (__MANAGE__) {
        warmLeadsFilter = _.filter(mainList, { leadType: 'Warm', status: '1' });
      } else {
        warmLeadsFilter = _.filter(mainList, { leadType: 'Warm', status: 'Unassigned' });
      }
      warmLeadsCount = _.size(warmLeadsFilter);
    }
    if (columnData === this.props.activeFilter && this.props.filterValues
      && this.props.filterValues[columnData].length > 0) {
      return this.props.activeFilterReplica;
    }
    let origlist = '';
    if (columnData === 'campaign') {
      origlist = _.orderBy(
        _.compact(
          _.uniq(
            _.flattenDeep(
              _.map(mainList, columnData)
            )
          )
        )
      );
    } else if (columnData === 'campaignPurpose') {
      origlist = _.orderBy(
        _.compact(
          _.uniq(
            _.flattenDeep(
              _.map(mainList, columnData)
            )
          )
        )
      );
    } else {
      origlist = _.orderBy(_.compact(_.uniq(_.map(mainList, columnData))));
      if (!__MANAGE__ && columnData === 'zip') {
        const newList = origlist.map(obj => obj.substr(0, 5));
        origlist = _.uniq(newList);
      }
      if (!__MANAGE__ && columnData === 'lineOneManager') {
        const { agentList } = this.props;
        const newList = [];
        agentList.forEach((element) => {
          if ((element.cica_positioncode == '10' && (element.cica_salesforce == '19' || element.cica_salesforce == '18')) || ((element.cica_positioncode == '60' || element.cica_positioncode == '76' || element.cica_positioncode == '33' || element.cica_positioncode == '70') && element.cica_salesforce == '02')) { // eslint-disable-line
            let managerCode = element.cica_agentcode;
            managerCode = managerCode.toUpperCase();
            let agentManagerName = element.fullname;
            agentManagerName = agentManagerName.split(' ');
            agentManagerName = `${agentManagerName[1]}, ${agentManagerName[0]} (${managerCode})`;
            newList.push(agentManagerName);
          }
        });
        origlist = _.sortBy(_.uniq(newList));
      }
      if (!__MANAGE__ && columnData === 'activeLastSellingAgentName') {
        const { agentList } = this.props;
        // lastSellingAgentList = this.getLastSellingAgentList();
        const newList = [];
        agentList.forEach((element) => {
          if ((element.cica_positioncode == '04' && (element.cica_salesforce == '19' || element.cica_salesforce == '18')) || ((element.cica_positioncode == '04' || element.cica_positioncode == '31' || element.cica_positioncode == '36' || element.cica_positioncode == '75') && element.cica_salesforce == '02')) { // eslint-disable-line
            let agentCode = element.cica_agentcode;
            agentCode = agentCode.toUpperCase();
            let agentName = element.fullname;
            agentName = agentName.split(' ');
            agentName = `${agentName[1]}, ${agentName[0]} (${agentCode})`;
            newList.push(agentName);
          }
        });
        origlist = _.sortBy(_.uniq(newList));
      }
      if ((!__MANAGE__ || __MANAGE__) && columnData === 'tier') {
        origlist = _.uniq((origlist.sort((a, b) => a - b)));
      }
    }
    let filteredList = '';

    if (columnData === 'campaign') {
      filteredList = _.orderBy(
        _.compact(
          _.uniq(
            _.flattenDeep(
              _.map(this.props.list, columnData)
            )
          )
        )
      );
    } else if (columnData === 'campaignPurpose') {
      filteredList = _.orderBy(
        _.compact(
          _.uniq(
            _.flattenDeep(
              _.map(this.props.list, columnData)
            )
          )
        )
      );
    } else {
      filteredList = _.orderBy(_.compact(_.uniq(_.map(this.props.list, columnData))));
      if (!__MANAGE__ && columnData === 'zip') {
        const newList = filteredList.map(obj => obj.substr(0, 5));
        filteredList = _.uniq(newList);
      }
      if (!__MANAGE__ && (columnData === 'lineOneManager' || columnData === 'activeLastSellingAgentName')) {
        filteredList = _.sortBy(_.uniq(filteredList));
      }
      if ((!__MANAGE__ || __MANAGE__) && columnData === 'tier') {
        filteredList = _.uniq((filteredList.sort((a, b) => a - b)));
      }
    }
    let filteredIndex = 0;
    let shouldDisableField = false;
    return origlist.map((item) => {
      // debug('fillOptions - before list map - item', item);
      if (item !== filteredList[filteredIndex]) {
        shouldDisableField = true;
      } else {
        shouldDisableField = false;
        filteredIndex += 1;
      }
      return {
        clearableValue: false,
        disable: shouldDisableField,
        value: (item.indexOf('-') !== -1 || columnData === 'activeLastSellingAgentName' || columnData === 'lineOneManager' || item.typeof !== 'boolean') ? item : util.toTitleCase(item),// eslint-disable-line
        label: (columnData === 'leadType' && util.toTitleCase(item) === 'Warm' && this.props.activeIndex === 0) ?//eslint-disable-line
        `${util.toTitleCase(item)} (${warmLeadsCount})` : (columnData === 'activeLastSellingAgentName' || columnData === 'lineOneManager' || item.indexOf('-') !== -1) ? item : util.toTitleCase(item)
      };
    });
  }

  dataForFilters = ({ options }) => {
    if (!this.props.list.length) {
      return [];
    }

    return this.fillOptions(options);
  }

  renderFilterViews = () => {
    const loginUserRecord = this.props.loginUserRecord;
    const views = this.props.filterData.map((record) => {
      const isCampaignInArray = this.props.filterValues.leadType.find(element => element === 'Campaign');
      if (record.type === 'campaign' && isCampaignInArray === undefined) {
        return null;
      }
      if ((record.type === 'campaignPurpose' || record.type === 'campaignType') && isCampaignInArray === undefined) {
        return null;
      }
      if (!__MANAGE__) {
        const isActiveLineManagerArray = this.props.filterValues.lineOneManager;
        if (record.type === 'activeLastSellingAgentName' && isActiveLineManagerArray.length <= 0) {
          return null;
        }
        if ((record.type === 'lastSelling' || record.type === 'isOrphaned') && isActiveLineManagerArray.length > 0) {
          return null;
        }
      }
      if (!__MANAGE__) {
        const isActiveLineManagerArray = this.props.filterValues.isOrphaned.find(element => element === 'Orphan Only');
        if ((record.type === 'lineOneManager' || record.type === 'activeLastSellingAgentName') && (isActiveLineManagerArray === 'Orphan Only' || (loginUserRecord.cica_positioncode === '10' && (loginUserRecord.cica_salesforce === '19' || loginUserRecord.cica_salesforce === '18')) || ((loginUserRecord.cica_positioncode === '60' || loginUserRecord.cica_positioncode === '76' || loginUserRecord.cica_positioncode === '33' || loginUserRecord.cica_positioncode === '70') && loginUserRecord.cica_salesforce === '02'))) {
          return null;
        }
      }
      return (
        <div className={styles.filterItem} key={record.label}>
          <label htmlFor={record.label}> {record.label} </label>
          <VirtualizedSelect
            labelKey="label"
            options={this.dataForFilters(record)}
            valueKey="value"
            type={record.type}
            hintText={record.hintText}
            allFilters={this.props.filterValues}
            updateFilter={this.props.updateFilter}
            applyFilter={this.props.applyFilter}
            filterValues={this.props.filterValues[record.type]}
            activeFilter={this.props.setActiveFilter}
            replica={this.props.replicateActiveFilter}
            activeIndex={this.props.activeIndex}
            updateNameSearchParameter={this.props.updateNameSearchParameter}
            updateStreetSearchParameter={this.props.updateStreetSearchParameter}
            updatePhoneParameter={this.props.updatePhoneParameter}
            currentLanguage={this.props.currentLanguage}
            updateSelectedRecords={this.props.updateSelectedRecords}
          />
        </div>
      );
    });
    return _.compact(views);
  }
  /* eslint-disable */
  renderFilterExpanded() {
    const { strings } = this.props;
    return (
      <div className={styles.flexWrapperExpanded}>
        <div className={styles.filterBody}>
          {this.renderFilterViews()}
        </div>
        <div className={styles.filterCloseContainer}>
          <div className={styles.closeIconWrapper}>
            <img
              src="static/filter_close_btn.png"
              className={styles.filterCloseIcon}
              alt="Filter"
              onClick={this.filterClick}
            />
          </div>
          <div className={styles.clearFilterContainer}>
            <Button raised theme={styles} onClick={this.clearAll}> {strings.clearFilter} </Button>
          </div>
        </div>
      </div>
    );
  }

  renderFilter = () => (
    <div className={styles.flexWrapper}>
      {!__MANAGE__ && <div className={styles.emptySpace} />}
      {this.setFilterChipValues().map((chip, index) => (
        <FilterChip
          label={chip.label}
          value={chip.value}
          campname={chip.campname}
          id={chip.id}
            /* In assign starting from index + 1 as the first column is Select check box and there is no filter for it
            */
          flexValue={`${__MANAGE__ ? this.props.flexValues[index] : this.props.flexValues[index + 2]}`}
          key={index}
          paddingLeft={chip.paddingLeft}
          marginRight={chip.marginRight}
          leadTypeData={chip.leadTypeData}
        />
      ))}
      <div className={styles.filterContainer}>
        <img
          src="static/filter_ico.png"
          className={styles.filterIcon}
          style={ this.props.isFiltered ? {background: '#55bdfc'} : {}}
          alt="Filter"
          onClick={this.filterClick}
        />
      </div>
    </div>
  );

  render() {
    debug(`Filter button state...${this.props.filterExpanded}`);
    return (
      <div
        className={this.props.filterExpanded ? styles.flexContainerExpanded : (__MANAGE__) ? styles.manageFlexContainer : styles.flexContainer}
      >
        {this.props.filterExpanded ? this.renderFilterExpanded() : this.renderFilter()}
      </div>
    );
  }
}

/*
Following Actions are being mapped to props
  1) setActiveFilter
  2) replicateActiveFilter
  3) resetActiveFilter
*/

const mapStateToProps = state => ({
  activeFilter: state.filter.activeFilter,
  activeFilterReplica: state.filter.activeFilterReplica
});

export default connect(mapStateToProps, actions)(Filter);



// WEBPACK FOOTER //
// ./src/containers/Filter/Filter.js